var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _rect, _rect2, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegurnetB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1316 601.3",
    style: {
      enableBackground: "new 0 0 1316 601.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F1F1F1;}\r\n\t.st1{fill:none;stroke:#484848;stroke-miterlimit:10;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:none;stroke:#6D6E71;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st4{fill:#707070;}\r\n\t.st5{fill:none;stroke:#707070;stroke-width:0.2697;stroke-miterlimit:3.86;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#ED6B17;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#707070;}\r\n\t.st8{fill:#ED6B17;}\r\n\t.st9{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.4,409.9c0,139.3,301.4,190.5,582,190.5c280.7,0-89.1-140,195.7-283.4C1267.3,222.7,820.7-147.8,572,64.8 S302.4,270.6,302.4,409.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.9,452.9l6-116.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,336.8L88,563.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.9,336.2l67.4,0.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.6,450.2l-25.4,0.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.3,368.2l-24.7,0.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.6,368.9l-3.3,82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,362.2H57.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,343.5l0.7,18.7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.3,341.5l-40.7,2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.6,343.5l-26.7-7.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.3,362.2l-3.3,86"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.3,460.2l5.3-123.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.8,445.6l0.7-108.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.2,437.6l2-100.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,336.8h182.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.8,442.2l1.3-72"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.5,370.2h-39.4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.1,441.6l1.3-71.4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.7,438.2l0.7-68"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.5,370.2h-50.1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.4,436.9v-66.7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.3,441.6l2.7-71.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.4,370.2H144"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.7,439.6l3.3-72"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.2,367.5H140"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.7,363.5v-21.3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.5,363.5H130.7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,367.5l-9.3-4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.5,341.5l-160.8,0.7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,336.8l22,5.3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,370.2h-40.7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.2,440.2v-70"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.9,434.9v-69.4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.6,365.5h-46.7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.2,343.5l-0.7,18.7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,362.9l-49.4-0.7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.2,336.8l12,6.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.3,336.8h-62.1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.2,343.5h50.1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.3,336.8l-1.3,153.4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.9,561.6v-53.4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.6,561.6v-9.3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.6,488.3l4-392.9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.9,92L4.5,512.3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.9,322.8l66.1,0.7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.6,122.1h64.7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98,323.5l5.3-201.4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.6,122.1l-6.7,200.8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98,310.8l-50.7,0.7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.3,260.8l-52.1-0.7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.2,311.5v-51.4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,244.1l-24.7-0.7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102,168.1l-24.7,0.7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.3,243.5l2-74.7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.9,260.1l1.3-94.1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.6,166.1H69.3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.6,160.1l-36.7,0.7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.3,134.1l0.7,26.7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.6,123.4l26.7,10.7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.3,134.1h-38"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.9,160.7l3.3,5.3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,246.8H72.6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.6,166.1v80.7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,323.5l5.3-201.4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.5,323.5l4.7-198.8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,122.1l182.2,2.7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,323.5h182.9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124,314.8l167.5-0.7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.7,260.1l170.2,2"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122,312.8l2.7,2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.7,260.1l-0.7,54"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.7,135.4v27.3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.2,164.1l-155.5-1.3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.7,135.4l157.5,1.3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,122.1l24.7,13.3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,168.7h149.5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,246.8h148.2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,168.7v78"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150,172.7h50.1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.4,244.1h48.7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.1,172.7l-2,71.4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150,172.7l-0.7,71.4"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,260.1l1.3-96.7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.4,172.7l45.4,0.7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.1,244.1h46.7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.8,173.4v70.7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.4,172.7l-2.7,71.4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.8,244.1h37.4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.1,172.7l36.7,0.7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.8,244.1l1.3-71.4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.9,323.5h63.4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.2,314.8l54.1-1.3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.9,323.5l3.3-199.4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.3,124.7l-62.1,0.7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.3,323.5l2-198.8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.9,163.4h46.7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.5,137.4l48.7-1.3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.2,125.4l13.3,12"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.9,163.4l-1.3-26"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.5,172.7h40"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.5,245.5h39.4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.5,172.7v72.7"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.9,250.8h-42.7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.5,168.7h44.7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.2,250.8l-0.7-82"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.9,92l367.7,3.3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,117.4l-16-22"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,145.4v-28"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.3,156.7l-10.7-11.3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.6,184.8l47.4,0.7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.3,156.7l-0.7,28"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,145.4h58.1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,335.5l56.1-0.7"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.7,145.4l-2,189.4"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409,324.8l50.7,0.7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.6,276.1h54.1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409,324.8l-1.3-48.7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.3,266.8h44"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.3,188.8h45.4"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.3,266.8v-78"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423,196.1l-0.7,66"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.7,195.4v67.4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.3,262.1l19.4,0.7"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423,196.1l18.7-0.7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445,262.8h15.4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445,194.8h15.4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445,262.8v-66"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405,348.2h55.4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405,490.9v-14"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.4,488.3l0.7-24.7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405,476.9h53.4"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411,452.9h42"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411,476.2v-23.3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M460.4,348.2v84.7"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413,370.2h47.4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405,348.2l8,5.3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413,370.2v-16.7"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413,452.9v-82.7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.3,374.9h42"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.3,374.9v74"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.7,448.9h-29.4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.4,145.4h129.5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M472.4,275.5l129.5,0.7"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M471,145.4l2.7,189.4"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M601.9,145.4l2,188.8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.9,334.2l-130.1,0.7"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502.4,191.4l1.3,73.4"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M578.5,191.4l-0.7,75.4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502.4,191.4h76.1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M503.7,264.8h74.1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473,324.8h130.8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M614.5,334.8h54.7"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669.3,147.4v187.4"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M612.5,147.4l2,187.4"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669.3,147.4h-56.7"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.3,156.7h47.4"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M477.7,156.7h115.5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M471,145.4l6.7,11.3"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M601.9,145.4l-5.3,11.3"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.2,188.8h56.1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.2,158.7h56.1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.9,276.1h55.4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M614.5,323.5h54.7"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.5,266.8h50.1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M614.5,193.4h52.1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.5,266.8l-2-73.4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M666.6,193.4v71.4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M637.9,196.8l0.7,66"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.9,196.8h18"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.9,262.8h18.7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.9,196.8v66"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M643.2,196.8h18"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M643.2,262.8h18"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M643.2,196.8v66"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M661.3,196.8v66"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.6,117.4l408.4,8"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M811.4,147.4l1.3-23.3"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.7,158.7l8.7-11.3"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686.6,158.7h116.1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686.6,147.4h124.8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M689.3,498.3l-2.7-350.9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M686.6,163.4l112.1,0.7"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.9,263.5l112.1-0.7"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.9,268.8l112.8-0.7"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M798.7,164.1l1.3,98.7"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.7,158.7l1.3,135.4"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.9,366.9h111.5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M800.7,268.1l2,99.4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.7,380.9l23.4-11.3"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M804.1,294.1l20-18"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M826.1,369.5l-2-93.4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.9,372.9h113.5"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.7,380.9l-1.3-8"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M698,513.6h40.7"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M698,380.2v133.4"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M738.7,513.6V380.2"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M698,380.2h40.7"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756,380.2l1.3,133.4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M796.1,513.6l-0.7-133.4"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756,380.2h39.4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M757.4,513.6h38.7"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M744.7,372.9l2.7,150.7"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M692,524.9l118.1-1.3"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.7,380.9l6-0.7"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M810.1,523.6l-1.3-143.4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M822.1,529.6l-12-6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M828.8,542.3l-5.3-3.3"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M829.4,553l-0.7-10.7"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M823.4,538.9l-0.7-7.3"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M826.1,369.5l482.5-0.7"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M829.4,553l6,3.3"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M852.8,554.3l-17.4,2"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M831.4,369.5l4,186.8"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M849.5,369.5l3.3,184.8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M699.3,542.3h128.1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M685.9,530.9l136.2-1.3"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M678.6,554.3l150.8-1.3"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669.3,493.6V347.5"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.2,394.9v-49.4"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669.3,345.5h-56.1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.2,370.2h53.4"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.5,452.2h50.1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M666.6,370.2v82"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M645.2,446.9h16"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.3,432.2v14.7"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.5,394.9v-19.3"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M661.3,375.5v10"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.5,375.5h44.7"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M730,372.9l2,150.1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M763.4,372.9v149.4"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M475,370.2h128.1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M475,353.5v16.7"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.9,350.8H475"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469.7,347.5l5.3,3.3"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.9,345.5v62.7"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.9,441.6v48"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.2,444.2l1.3,49.4"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467,486.3l0.7-15.3"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469,432.2l0.7-84.7"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.9,345.5H469.7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479,374.9l-0.7,57.4"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.9,372.9l-124.8,2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.1,452.9l106.8-0.7"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M563.8,446.9h34.7"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M563.8,376.9h34.7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M598.5,446.9v-70"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M563.8,446.9v-70"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M524.4,446.9h34.7"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M524.4,376.9h34.7"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M524.4,446.9v-70"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M559.1,446.9v-70"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.7,426.2l0.7-49.4"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.1,446.9h23.4"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M520.4,376.9v70"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M484.4,376.9h36"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M491.7,476.9h19.4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543.8,478.2l60.1-1.3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651.2,476.2h18"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M854.1,524.3l248.3-4"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1099.7,369.5l2.7,150.8"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1295.9,100l18.7,454.2"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M824.1,276.1h479.2"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M803.4,124.7l24-28"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M829.4,276.1l-2-179.4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1295.9,100l-468.5-3.3"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M844.1,141.4h90.8"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M846.1,242.1l91.4-0.7"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M934.9,141.4v100.1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M844.1,141.4l2,100.7"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M886.8,141.4l1.3,100.7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M890.2,147.4l39.4,0.7"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M894.2,235.4h36"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M929.5,148.1l0.7,87.4"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M890.2,147.4l4,88"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M885.5,147.4h-34"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M852.8,235.4h35.4"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M849.5,147.4l3.3,88"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M944.9,141.4l1.3,100.7"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1093.1,141.4l2.7,99.4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1018.3,140.7l2,102.1"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M946.2,242.1l230.9-1.3"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1174.5,143.4l2.7,97.4"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M944.9,141.4l229.6,2"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1186.5,143.4h90.1"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1189.2,240.8l89.4-1.3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1227.9,143.4l3.3,96.7"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1186.5,143.4l2.7,97.4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1189.2,150.1l37.4-0.7"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1193.8,236.8h37.4"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1189.2,150.1l2.7,87.4"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1232.6,149.4l38.7-0.7"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1235.2,236.8h38"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1271.3,148.7l2,88"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1232.6,149.4l2.7,87.4"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1276.6,143.4l2,96.1"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1098.4,148.1h67.4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1101.1,235.4h68.7"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1023,148.1l70.1,2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1024.3,235.4h71.4"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1023,148.1l1.3,87.4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1019.7,236.8h-67.4"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M949.6,148.1l68.7,0.7"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M950.2,236.8l-0.7-88.7"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1098.4,148.1l2.7,87.4"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1102.4,520.3l212.2,34"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 947.3,
    y: 277.1,
    className: "st2",
    width: 241.1,
    height: 91.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 511,
    y: 200.6,
    className: "st2",
    width: 57.4,
    height: 53.7
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.9,559c-7.5,1.5-26.1,11.2-31.1,1.2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.2,565c-7.2-0.2-7.2-2.3-7.2-8.4c0-3,5.6-3.6,8.4-3.6"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19,557.8c-8.2-5.1-13-10.4-6-19.2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.6,541c-6.1,0-15.6,1.9-15.6-6.6c0-7.9,6.3-7.8,13.2-7.8"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.6,529.1c-9.9-4.4-8.3-15.6,2.4-15.6"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13,515.9c-12.4-9.7,3.3-14.4,12-14.4"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.8,503.9c-15.4-15.4-0.1-24.3,13.2-28.7"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.4,482.4c0-10.1-1.2-25.1,13.2-25.1"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.9,464.4c-0.6-3.9-3.4-11.4,1.3-13.8c8.2-4.1,15.1-5.6,24.2-5.4c5.9,0.1,14,1.2,14,8.4"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.9,554.2c0.9,3.9,2.7,11,6.5,13.2c3.2,1.8,8.3,6,12,6c6.4,0,16.3,2,22.2-0.3c4.7-1.8,7.5-6.6,12-8.1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,457.2c5.1-4,6.4-4.8,12.6-4.8c4,0,5.2,1.8,8.4,2.5c6.2,1.4,8.3,14.4,11.4,19.1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.2,545.8c-6.6,1.3-7.2,1.2-9.6,6.6c-1.1,2.4-2.4,5.5-2.4,8c0,5.7-0.3,12.9,7.2,12.9"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.6,560.2c6.6,6.8,12.3,12,22.1,12c9.5,0,18.6,1,22.2-9.6"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.3,563.8c5.6,5.6,7.3,8.4,15,8.4c3.1,0,9.1-0.5,11.9-1.8c6.3-2.9,11.9-5.2,15-11.4"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.8,560.2c12.9,12.5,34.7,7.2,49.1,0"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.8,560.2c7.8,5.9,10.7,8.6,20.4,8.4c10.1-0.2,26.8,0.4,29.9-12"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.5,563.8c14,2.7,30.3,0.9,40.7-9.6"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M272.8,562.6c11.1,4.3,21.4,3.6,33.3,3.6c3,0,8.3,0.4,10.1-2.4c1.8-2.8,3.8-8.9,5.7-10.8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.7,560.2c5.2,5,6.3,6,12.9,6c4.1,0,8.2,0,12.2,0c6.4,0,14.4-3.7,14.4-10.8"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M343.4,565c11.3,0,19.2-6.6,19.2-18"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.6,545.8c-7.3-5.7-5.3-11.6,0.5-17.9c2.2-2.4,7.9-2.6,9-4.9"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.8,526.7c-14.7-6.1-24.6-22.1-4.8-28.7"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.2,502.7c-4.4-3.6-8.2-13.8-1.8-17.4c3.9-2.2,9.5-4.2,13.8-4.2"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.4,483.6c-2.5-6.5-5.3-17.2,2.4-21.3c4.7-2.5,10-2.7,15.6-2.7"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.2,462c5.1-11.9,15.7-14.4,27.5-14.4"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.9,452.4c10.5-2.5,23.9-8.5,29.9,3.6"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.6,453.6c7.4-1.4,14-2.4,21.6-2.4c4.9,0,7.9,2.8,12,4.8"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.6,457.2c-2.1-5.4-3.4-13.7,5.1-14.4c5.8-0.4,11.4-1.2,17.4-1.2c4.8,0,9.5,1.8,13.2,5.1 c2.3,2.1,5.2,7,7.4,8.1"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M215.3,453.6c3-7,9.8-9.6,17.4-9.6c4.5,0,11.2-1.3,15,1.2"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.9,452.4c7-5.5,11.8-7.2,21-7.2c4.5,0,11.5,0.3,13.8,4.8"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M264.4,452.4c7.1-5.2,31.6-12.2,37.1-1.2"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.3,448.8c3.9-9.2,10.8-9.6,19.8-9.6c7.1,0,11.9,6.9,17.4,9.6"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M323.1,454.8c7.7-1.7,19.3-5.3,26.4,0.6c5.2,4.3,14.3,6.4,14.3,13.8"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.5,481.2c6.2-4.5,10.7-4.8,18-4.8c5.9,0,9.5,5.9,13.2,9.6"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M349.4,491.9c2.1,1.3,6.2,2.5,7.4,4.8c0.5,0.9,0.7,3.1,1.6,3.6c4,2.3,1.7,4.5,3.2,7.8c1,2.4,0.9,4.4,0.9,7.1 c0,3.3-3.6,3-4.8,5.4"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M390.2,535.6c-5.8,1.4-6.9,10.9-6.9,15.9c0,2.7,3.2,6,5.5,7c1.3,0.6,2.5,0.9,4,0.9c1.2,0,4-0.5,4.5-1.5"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M391.6,556.4c5.5,2.2,10.3,2.5,16.4,2.5"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.2,538.6c-3.4-2.6-2.5-6.2-2.5-10.2c0-3,3.1-4.9,5.5-5.7"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M388.2,523.2c-8.5,0-9.4-7.5-9.4-14.4c0-7.1,10.1-8.3,14.9-5.9"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M385.7,505.4c-3.1-1.2-3.5-1.5-3.5-4.7c0-1.8-0.4-3.7,0.9-5.1c2.2-2.3,4.3-4.6,6.8-6.5c2.7-2.1,4.3-5.1,6.8-7.3 c0.9-0.8,3.7,1.1,4.6,1.4c1.3,0.4,2.7,3.8,3.2,4.9c1.4,2.9,2.4,10.7-1,12.4"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M405,498c2.6-4.4,6.1-9.4,11.9-9.4c4.4,0,8.8-0.4,12.9,1"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M424.3,497.5c1.9-3.3,3.7-6.5,6.9-8.3c2.6-1.5,7.2-1.1,10.2-1.1c1.5,0,3.1-0.1,4.6,0c1.1,0,2.2,1.2,3.3,1.5 c2.3,0.5,4.4,2.5,6.7,2.5"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M452.1,493c3.2-4.4,7.2-5.9,12.6-5.9c1.8,0,5.3-0.7,6.9,0.2c1.2,0.7,3.5,1.8,4.7,2.2"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M476.9,489.1c-2.8,0-7.9-0.2-7.9-4.2c0-3.4-1.9-7.2,3-7.2c2.8,0-0.7-0.3-1-1.3c-0.3-1-0.3-3.6,0.7-4.2 c2-1.1,3.6-1.6,5.7-2.5c2.4-1,4.1,0,6.4,0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490.7,487.6c0-2.4,0.6-4.5,0.5-6.9c-0.1-1.7-1.6-3.1-2.4-4.5c-2-3.4-6.3-4.5-10-4.5"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490.3,486.1c4.4-1.7,12.9-0.9,12.9,5.5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M501.6,490.5c2.8-4.5,6.4-5.5,11.6-5.5c2.8,0,7.2-0.5,8.7,2.5"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M474.4,468.2c-3.8-1.6-5.9-2.1-5.9-6.4"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M474.4,471.2c-3.4-0.7-5.6-1.7-8.4-3.1c-2.6-1.3-2.5-3.8-2.5-6.3"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M469.4,459.8c-5.6,4.1-12.1,4.9-17.6,0.5c-2.1-1.7-1.7-6.2-1.7-8.7c0-2.7,5.3-4.2,7.4-4.2"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M452.6,448.4c-3.9-0.9-3-4.1-3-7.4c0-1.8,2.7-3.6,4.2-4.5c2.3-1.3,3.7-2,6.5-2c2.5,0,4.9,1.5,7.2,1.5"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M465,435.5c3.4-4.7,8.4-5.4,14.1-5.4c2.4,0,4.2,1.5,6.4,2c1.5,0.3,6,3.2,6.7,4.7c1,2.2,2.7,4.4,3.9,6.7 c1.4,2.8,1.1,6.2,1.1,9.3c0,5.6-5.3,8-10.4,8"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M468.4,459.8c3.9,0.1,8.7,3.7,12.9,1.9c3.6-1.6,7.4-4.1,7.4-8.3"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M523,491.5c0-3.8,0.4-7.5-3.5-9.4"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M522,483.1c-3.3,0-6.3-0.6-7.5-4.1c-0.9-2.6-0.4-6-0.4-8.8"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M515,473.2c-3.8,0-7.1,0.8-8.9-3.2c-1.3-2.9-1.5-5-1.5-8.2c0-6.6,7.2-7.4,12.4-7.4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514,455.9c2.4-5.7,10.5-6.7,15-3.1c1.9,1.5,3.9,1.7,5.2,4.1c1.2,2.1,1.6,5,1.6,7.4"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M534.8,462.3c6.8,0,9.9,5.6,9.9,11.9c0,6.2-5,9.9-10.9,9.9"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M537.8,484.1c-2.2,1.6-3,2.2-3,5"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M532.4,491.5c2.5-1.9,3.9-3.7,6.4-5.1c2.3-1.2,5.2-0.9,7.7-0.9c3,0,4.7,0.3,7.4,1.5c2,0.9,5.1,2.6,5.7,4.5"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M557.6,491c5.3-3.8,10.4-4,16.8-4c5,0,9,3.3,13.4,5.5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M584.4,490.5c4.6-3.6,7.9-5,13.9-5c3.9,0,10.5,2.2,12.4,5.9"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M610.2,490c6.4-1.2,12.4,2.8,12.4,9.4"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M622.6,496c2.6-0.6,4.5-1.6,4.5-4.5c0-2.4-0.7-2.6-2-4.5"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M630.5,487.1c0,3.7,0.7,5.2,4,6.8c1.9,0.9,3.8,1.1,5.9,1.1"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M637.9,495.5c0.8-3.7,3.3-3.9,6.7-4.4c1.2-0.2,6.6-1.7,7.6-0.9c2.5,2,5,4.2,6.6,7.3"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M657.7,496c2.1-5.4,5.5-5.5,10.9-5.5c2.7,0,6.6,0.8,7.9,3.5"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M674.6,493.5c0-2.8-0.1-4.3,3-4.5c1.9-0.1,4.4-0.2,5.7,1.5c2.1,2.8,5.8,4,8.7,5.4"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M676.1,528.2c3.7-2.7,7.9-4,10.2-8.2c1.2-2.2,0.2-10.2,2-10.6c2.5-0.6,6.2-4.9,6.2-7.5c0-3.5-5-7.7-7.9-8.4"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M677.1,537.6c7.6-1.7,8.9-8.5,8.9-15.4"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M682.5,535.1c2.6,3.5,4.5,9.6,2.2,13.6c-1.6,2.8-6.2,2.7-9.2,2.7"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M660.2,553.5c2.2,0.5,3.4,2.2,5.5,2.5c2.2,0.3,4.4,0.5,6.7,0.5c3.3,0,6.1-1.6,7.2-5"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M412.5,555c5,6.5,12.2,7.9,20.3,7.9c4.5,0,8.5-2.8,12.4-4.6c3.6-1.6,10.1-0.4,14.1-0.4c1.6,0,4.5,0.1,5.7-1 c1.3-1.1,3.7-0.7,4.9-1.7c2.6-2.2,9.4,1.6,12.4,2.5c5.5,1.7,13.2,0.9,18.8,0.2c2-0.2,3.7-1.3,5.6-1.8c1.4-0.4,3-1.6,4.4-1.6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514,552.5c1.6,2.2,2.2,3.9,4.8,4.8c2.6,0.9,6.3,1.1,9.1,1.1c2.7,0,5.9,0.5,8.4-0.8c1.4-0.7,3.9-2,4.5-3.2"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M540.3,554.5c4.4,1.7,8.3,1.5,13,1.5c3.4,0,5.2-2,8.3-2.5c1.3-0.2,5-2.1,5.5-3"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M564.6,554.5c10.2,3.9,20.6,0.6,29.7-4"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M598.3,552c2.9,1.8,5.6,3.5,9,3.5c2.9,0,5.9,0,8.8,0c3.1,0,5.7-0.4,8.6-1.5c2.1-0.8,5.2-3.5,7.2-3.5"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M633,553.5c3,1.3,4.5,2.5,7.9,2.5c2.6,0,5.2,0,7.8,0c5.7,0,10.9-2.4,15.5-5.5"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M630.5,488.1c3.2,0.6,6.2,1.2,8.7-1.2c2.4-2.4,2.7-4.4,2.7-7.7"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M641.9,483.6c1.5-1.1,2.8-1.6,4.1-2.9c0.6-0.6,1.1-1.7,1.6-2.1c0.9-0.7,0.2-5.1,0.2-6.2c0-3.5-4.7-6.2-7.9-6.2"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M614.6,483.1c1.9,0.8,3.9,2.9,5.9,3c1.6,0.1,3.3,0,5,0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M613.6,470.7c0.9-4,5.9-7.2,9.4-8.8c3.2-1.4,9.1,0.1,11.4,2.4"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M632,463.8c4.8-1.8,9.5-0.8,11.9,4"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M626.5,462.8c-6.7-2.8-8.7-10.5-6.4-17.3"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M627,461.3c-2.4-1.7-2.1-1.8-3.1-4c-0.5-1.1-0.5-2.1-1.3-3.1c-0.6-0.7-0.1-3-0.1-3.9c-0.1-1.4-1-2.5-1-4"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M634.4,463.8c2.6-3.6,2.6-13.2-1.5-15.9"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M637.4,462.8c1.2-3.1,1.5-5.9,1.5-9.2c0-2.6-2.1-4.3-4-5.2"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M607.7,433.6c-0.7,3.5,0.8,5.3,3.7,6.9c0.8,0.5,1.2,1.5,2,2c1.1,0.6,2.3,1.1,3.4,1.7c2.2,1.2,5.8,1.2,8.3,1.2 c2.8,0,5-0.8,7.3-2"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M629.5,442.5c0.1,4.9,3.2,5.2,6.9,6.8c1.3,0.6,7,1.5,8.3,0.5c1.9-1.4,4.8-2.6,7-3.7c3-1.5,3.5-4.5,3.5-7.5"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M651.3,441.5c3.1,0,6.6,0.7,9.2-1.3c1.9-1.4,2.7-3.5,4.3-5.1c1.4-1.4,2.4-4.2,2.4-6.3c0-1.2,0-2.3,0-3.5 c0-1.7-1.5-1.7-2.5-2.7"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M607.7,433.6c-3.9-0.8-7.4-4.5-5.2-8.9c2.2-4.4,5.2-6.4,10.1-6.4"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M606.2,420.7c-2.1-2.2-2.5-4-2.5-6.9c0-1.6,0.6-5.2,2.3-5.9c2.7-1.2,4.5-4.2,7.6-5c2.3-0.6,4.6-0.5,7-0.5"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M611.7,403.8c-5.4-7.7,5.4-11.4,11.3-11.4c2.8,0,5.7,0,8.5,0c1.4,0,2.4-0.1,3.5,1c0.9,0.9,1.1,2.5,2.5,2.5"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M625.5,392.9c4.1-5,12.3-4.2,17.8-2.2c1.6,0.6,2.3,1.8,3.6,2.7c1.1,0.8,3.3,1.4,4,2.5c0.7,1.2,2.8,1.8,2.9,3.5 c0.1,1.4,0.5,2.5,0.5,4"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M654.3,399.9c4.7,0.1,10.6,6.6,12.4,10.7c0.6,1.4,1.9,2.2,2,3.8c0.1,1.5,0.5,2.8,0.5,4.4c0,2.3-0.8,5.4-3,6.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Segurnet RBG"), /*#__PURE__*/React.createElement("g", {
    id: "_7_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1031.5,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.6,0.3,1,0.4c0.3,0.1,0.6,0.1,0.9,0.1c0.2,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.4-0.5c-0.2-0.2-0.5-0.5-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.3,0,0.6,0.1,0.9 c-0.5-0.2-0.9-0.3-1.4-0.3c-0.3,0-0.5,0-0.8,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5l0.6,0.5c0.3,0.3,0.6,0.5,0.8,0.7 c0.1,0.1,0.3,0.3,0.4,0.5c0.2,0.3,0.3,0.6,0.3,1c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.7,0.3 c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.5,0-0.7-0.1C1032.2,360.4,1031.9,360.3,1031.5,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1031.5,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.6,0.3,1,0.4c0.3,0.1,0.6,0.1,0.9,0.1c0.2,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.4-0.5c-0.2-0.2-0.5-0.5-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.3,0,0.6,0.1,0.9 c-0.5-0.2-0.9-0.3-1.4-0.3c-0.3,0-0.5,0-0.8,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5l0.6,0.5c0.3,0.3,0.6,0.5,0.8,0.7 c0.1,0.1,0.3,0.3,0.4,0.5c0.2,0.3,0.3,0.6,0.3,1c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.7,0.3 c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.5,0-0.7-0.1C1032.2,360.4,1031.9,360.3,1031.5,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1036.9,360.4l0.1-2.1l0.1-3.9v-0.9c0-0.2,0-0.5,0-0.7h4.6c0,0.3,0,0.5,0,0.8l-0.5,0c-0.1,0-0.3,0-0.6,0 s-0.6,0-0.8,0c-0.8,0-1.4,0-1.7,0l-0.1,2.6c0.5,0,1,0,1.4,0c0.4,0,1.1,0,1.8,0c0,0.3,0,0.5,0,0.8l-1.8,0c-0.3,0-0.8,0-1.5,0 l-0.1,2.8h0.5c1,0,1.6,0,2,0s0.7,0,1.1,0c0,0.3,0,0.5,0,0.8h-2.1H1036.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1036.9,360.4l0.1-2.1l0.1-3.9v-0.9c0-0.2,0-0.5,0-0.7h4.6c0,0.3,0,0.5,0,0.8l-0.5,0c-0.1,0-0.3,0-0.6,0 s-0.6,0-0.8,0c-0.8,0-1.4,0-1.7,0l-0.1,2.6c0.5,0,1,0,1.4,0c0.4,0,1.1,0,1.8,0c0,0.3,0,0.5,0,0.8l-1.8,0c-0.3,0-0.8,0-1.5,0 l-0.1,2.8h0.5c1,0,1.6,0,2,0s0.7,0,1.1,0c0,0.3,0,0.5,0,0.8h-2.1H1036.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1046.9,356.1h2.5c-0.1,1.1-0.1,2.5-0.2,4c-0.9,0.2-1.8,0.3-2.7,0.4c-0.5,0-1.1-0.1-1.6-0.2 c-0.5-0.1-0.9-0.4-1.3-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.5-0.3-1-0.3-1.6c0-0.6,0.1-1.2,0.3-1.8c0.2-0.5,0.5-1,0.9-1.4 c0.4-0.4,0.8-0.6,1.3-0.8c0.5-0.2,1.1-0.3,1.7-0.2c0.8,0,1.5,0.1,2.2,0.3c0,0.3,0,0.6,0,0.9c-0.4-0.1-0.8-0.3-1.3-0.4 c-0.3-0.1-0.7-0.1-1-0.1c-0.5,0-0.9,0.1-1.3,0.2c-0.4,0.1-0.8,0.4-1.1,0.7c-0.3,0.3-0.6,0.7-0.7,1.2c-0.2,0.5-0.2,0.9-0.2,1.4 c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.3,0.7,0.6,0.9c0.3,0.3,0.6,0.4,0.9,0.6c0.4,0.1,0.8,0.2,1.2,0.2c0.3,0,0.6,0,0.8-0.1 c0.3,0,0.7-0.1,1-0.2l0.1-2.6h-0.5c-0.3,0-0.7,0-1.1,0C1046.9,356.5,1046.9,356.3,1046.9,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1046.9,356.1h2.5c-0.1,1.1-0.1,2.5-0.2,4c-0.9,0.2-1.8,0.3-2.7,0.4c-0.5,0-1.1-0.1-1.6-0.2 c-0.5-0.1-0.9-0.4-1.3-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.5-0.3-1-0.3-1.6c0-0.6,0.1-1.2,0.3-1.8c0.2-0.5,0.5-1,0.9-1.4 c0.4-0.4,0.8-0.6,1.3-0.8c0.5-0.2,1.1-0.3,1.7-0.2c0.8,0,1.5,0.1,2.2,0.3c0,0.3,0,0.6,0,0.9c-0.4-0.1-0.8-0.3-1.3-0.4 c-0.3-0.1-0.7-0.1-1-0.1c-0.5,0-0.9,0.1-1.3,0.2c-0.4,0.1-0.8,0.4-1.1,0.7c-0.3,0.3-0.6,0.7-0.7,1.2c-0.2,0.5-0.2,0.9-0.2,1.4 c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.3,0.7,0.6,0.9c0.3,0.3,0.6,0.4,0.9,0.6c0.4,0.1,0.8,0.2,1.2,0.2c0.3,0,0.6,0,0.8-0.1 c0.3,0,0.7-0.1,1-0.2l0.1-2.6h-0.5c-0.3,0-0.7,0-1.1,0C1046.9,356.5,1046.9,356.3,1046.9,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1051.1,352.7h1l-0.2,4.3v0.5v0.1c0,0.4,0.1,0.8,0.2,1.2c0.1,0.3,0.4,0.5,0.7,0.7c0.4,0.2,0.8,0.2,1.2,0.2 c0.3,0,0.6,0,0.9-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3,0.1-0.8,0.1-1.5l0.1-1.8 c0-0.7,0-1.4,0.1-2.1h1l-0.2,2.6l-0.1,2.2c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.3-0.3,0.4 c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.2-0.8,0.3c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.7,0-1.1-0.1c-0.3-0.1-0.6-0.2-0.9-0.3 c-0.2-0.1-0.4-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.4,0-0.7,0-1.2s0.1-1.1,0.1-2 S1051.1,353.2,1051.1,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1051.1,352.7h1l-0.2,4.3v0.5v0.1c0,0.4,0.1,0.8,0.2,1.2c0.1,0.3,0.4,0.5,0.7,0.7c0.4,0.2,0.8,0.2,1.2,0.2 c0.3,0,0.6,0,0.9-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3,0.1-0.8,0.1-1.5l0.1-1.8 c0-0.7,0-1.4,0.1-2.1h1l-0.2,2.6l-0.1,2.2c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.3-0.3,0.4 c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.2-0.8,0.3c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.7,0-1.1-0.1c-0.3-0.1-0.6-0.2-0.9-0.3 c-0.2-0.1-0.4-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.4,0-0.7,0-1.2s0.1-1.1,0.1-2 S1051.1,353.2,1051.1,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1058.6,360.4l0.1-1.5l0.1-2.8l0-2.3c0-0.5,0-0.8,0-1h1h0.8h0.7c0.3,0,0.6,0,0.9,0.1c0.5,0.1,1,0.5,1.2,0.9 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.2 c-0.2,0-0.4,0.1-0.7,0.1l0.9,1.6l0.9,1.6c0.1,0.1,0.2,0.3,0.3,0.5h-0.5h-0.6l-0.4-0.8c-0.1-0.2-0.2-0.3-0.2-0.4 c-0.1-0.1-0.2-0.3-0.3-0.5l-1.2-2.1c0-0.1-0.1-0.2-0.2-0.4c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.6 c0.2-0.3,0.2-0.6,0.2-0.9c0-0.2,0-0.3-0.1-0.5c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.2,0-0.3,0-0.5,0h-0.7h-0.6c-0.1,2.5-0.2,4.8-0.2,6.9h-0.5L1058.6,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1058.6,360.4l0.1-1.5l0.1-2.8l0-2.3c0-0.5,0-0.8,0-1h1h0.8h0.7c0.3,0,0.6,0,0.9,0.1c0.5,0.1,1,0.5,1.2,0.9 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.2 c-0.2,0-0.4,0.1-0.7,0.1l0.9,1.6l0.9,1.6c0.1,0.1,0.2,0.3,0.3,0.5h-0.5h-0.6l-0.4-0.8c-0.1-0.2-0.2-0.3-0.2-0.4 c-0.1-0.1-0.2-0.3-0.3-0.5l-1.2-2.1c0-0.1-0.1-0.2-0.2-0.4c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.6 c0.2-0.3,0.2-0.6,0.2-0.9c0-0.2,0-0.3-0.1-0.5c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.2,0-0.3,0-0.5,0h-0.7h-0.6c-0.1,2.5-0.2,4.8-0.2,6.9h-0.5L1058.6,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1068.4,353.3c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.2-0.7,0.4-0.9,0.7c-0.3,0.3-0.5,0.7-0.6,1.1 c-0.1,0.4-0.2,0.9-0.2,1.3c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.3,0.7,0.6,1c0.3,0.3,0.6,0.5,0.9,0.6c0.4,0.1,0.7,0.2,1.1,0.2 c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.4,0.9-0.7c0.3-0.3,0.5-0.7,0.6-1.1c0.2-0.9,0.2-1.8,0-2.6c-0.1-0.4-0.3-0.7-0.6-1 c-0.3-0.3-0.6-0.5-0.9-0.6C1069.1,353.4,1068.7,353.3,1068.4,353.3z M1068.4,352.6c0.5,0,1,0.1,1.5,0.2c0.5,0.2,0.9,0.4,1.2,0.8 c0.3,0.4,0.6,0.8,0.8,1.2c0.2,0.5,0.2,1,0.2,1.5c0,0.6-0.1,1.1-0.3,1.7c-0.1,0.5-0.4,1-0.8,1.3c-0.4,0.4-0.8,0.7-1.3,0.8 c-0.5,0.2-1.1,0.3-1.6,0.3c-0.5,0-1-0.1-1.5-0.2c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.8-0.7-1.2c-0.2-0.5-0.2-1-0.2-1.5 c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.4-1,0.8-1.4c0.4-0.4,0.8-0.6,1.3-0.8C1067.3,352.7,1067.9,352.6,1068.4,352.6L1068.4,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1068.4,353.3c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.2-0.7,0.4-0.9,0.7c-0.3,0.3-0.5,0.7-0.6,1.1 c-0.1,0.4-0.2,0.9-0.2,1.3c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.3,0.7,0.6,1c0.3,0.3,0.6,0.5,0.9,0.6c0.4,0.1,0.7,0.2,1.1,0.2 c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.4,0.9-0.7c0.3-0.3,0.5-0.7,0.6-1.1c0.2-0.9,0.2-1.8,0-2.6c-0.1-0.4-0.3-0.7-0.6-1 c-0.3-0.3-0.6-0.5-0.9-0.6C1069.1,353.4,1068.7,353.3,1068.4,353.3z M1068.4,352.6c0.5,0,1,0.1,1.5,0.2c0.5,0.2,0.9,0.4,1.2,0.8 c0.3,0.4,0.6,0.8,0.8,1.2c0.2,0.5,0.2,1,0.2,1.5c0,0.6-0.1,1.1-0.3,1.7c-0.1,0.5-0.4,1-0.8,1.3c-0.4,0.4-0.8,0.7-1.3,0.8 c-0.5,0.2-1.1,0.3-1.6,0.3c-0.5,0-1-0.1-1.5-0.2c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.8-0.7-1.2c-0.2-0.5-0.2-1-0.2-1.5 c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.4-1,0.8-1.4c0.4-0.4,0.8-0.6,1.3-0.8C1067.3,352.7,1067.9,352.6,1068.4,352.6L1068.4,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1072.9,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.6,0.3,1,0.4c0.3,0.1,0.6,0.1,0.8,0.1c0.3,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.5l-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.7,0.4-1.3,1-1.6c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.2,0,0.5,0.1,0.9c-0.5-0.2-1-0.3-1.4-0.3 c-0.3,0-0.5,0-0.8,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5c0.1,0,0.3,0.2,0.6,0.5s0.6,0.5,0.8,0.7c0.1,0.1,0.3,0.3,0.4,0.5 c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.4,0.1,0.5c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.7,0.3 c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.5,0-0.7-0.1C1073.6,360.4,1073.3,360.3,1072.9,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1072.9,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.6,0.3,1,0.4c0.3,0.1,0.6,0.1,0.8,0.1c0.3,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.5l-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.7,0.4-1.3,1-1.6c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.2,0,0.5,0.1,0.9c-0.5-0.2-1-0.3-1.4-0.3 c-0.3,0-0.5,0-0.8,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5c0.1,0,0.3,0.2,0.6,0.5s0.6,0.5,0.8,0.7c0.1,0.1,0.3,0.3,0.4,0.5 c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.4,0.1,0.5c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.7,0.3 c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.5,0-0.7-0.1C1073.6,360.4,1073.3,360.3,1072.9,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1085.1,359c-0.4-0.4-0.8-0.8-1.1-1.2c-0.3-0.4-0.6-0.8-1-1.2c-0.3,0.2-0.5,0.4-0.7,0.5 c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.5,0.2,0.7c0.2,0.2,0.4,0.4,0.6,0.5 c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.1,0.3-0.2C1084.9,359.2,1085,359.1,1085.1,359 z M1085.9,357h0.4h0.4c0,0.4-0.1,0.8-0.1,1.1c-0.1,0.4-0.2,0.7-0.4,1c0.2,0.2,0.4,0.4,0.6,0.7c0.2,0.2,0.4,0.4,0.6,0.6h-0.6h-0.5 l-0.8-0.8c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0.1-0.4,0.1-0.5,0.1 c-0.2,0-0.4,0-0.6,0c-0.4,0-0.9-0.1-1.3-0.3c-0.4-0.2-0.7-0.4-0.9-0.7c-0.2-0.3-0.3-0.7-0.3-1.1c0-0.2,0-0.4,0.1-0.6 c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.3-0.2,0.6-0.4,0.9-0.6c-0.2-0.3-0.4-0.6-0.5-1c-0.1-0.2-0.1-0.5-0.1-0.7 c0-0.2,0.1-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.2,0.4-0.3,0.6-0.4c0.2-0.1,0.5-0.1,0.8-0.1c0.2,0,0.4,0,0.6,0.1 c0.2,0,0.5,0.1,0.7,0.2c0,0.4,0,0.6,0,0.8c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.5,0-0.7,0.2 c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.1,0,0.3,0.1,0.4c0.1,0.2,0.1,0.4,0.2,0.5c0.2,0.4,0.4,0.7,0.7,1.1 c0.3,0.3,0.5,0.7,0.9,1c0.1,0.1,0.4,0.5,0.9,0.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.3,0.1-0.4 C1085.9,357.3,1085.9,357.1,1085.9,357z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1085.1,359c-0.4-0.4-0.8-0.8-1.1-1.2c-0.3-0.4-0.6-0.8-1-1.2c-0.3,0.2-0.5,0.4-0.7,0.5 c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.5,0.2,0.7c0.2,0.2,0.4,0.4,0.6,0.5 c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.1,0.3-0.2C1084.9,359.2,1085,359.1,1085.1,359 z M1085.9,357h0.4h0.4c0,0.4-0.1,0.8-0.1,1.1c-0.1,0.4-0.2,0.7-0.4,1c0.2,0.2,0.4,0.4,0.6,0.7c0.2,0.2,0.4,0.4,0.6,0.6h-0.6h-0.5 l-0.8-0.8c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0.1-0.4,0.1-0.5,0.1 c-0.2,0-0.4,0-0.6,0c-0.4,0-0.9-0.1-1.3-0.3c-0.4-0.2-0.7-0.4-0.9-0.7c-0.2-0.3-0.3-0.7-0.3-1.1c0-0.2,0-0.4,0.1-0.6 c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.3-0.4,0.5-0.6c0.3-0.2,0.6-0.4,0.9-0.6c-0.2-0.3-0.4-0.6-0.5-1c-0.1-0.2-0.1-0.5-0.1-0.7 c0-0.2,0.1-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.6c0.2-0.2,0.4-0.3,0.6-0.4c0.2-0.1,0.5-0.1,0.8-0.1c0.2,0,0.4,0,0.6,0.1 c0.2,0,0.5,0.1,0.7,0.2c0,0.4,0,0.6,0,0.8c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.5,0-0.7,0.2 c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.1,0,0.3,0.1,0.4c0.1,0.2,0.1,0.4,0.2,0.5c0.2,0.4,0.4,0.7,0.7,1.1 c0.3,0.3,0.5,0.7,0.9,1c0.1,0.1,0.4,0.5,0.9,0.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.3,0.1-0.4 C1085.9,357.3,1085.9,357.1,1085.9,357z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1091,360.4l0.1-1.5l0.1-2.8l0.1-2.3c0-0.5,0-0.8,0-1h1h0.8h0.7c0.3,0,0.6,0,0.9,0.1c0.5,0.1,1,0.5,1.2,0.9 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.2-0.3,0.3-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.2 c-0.2,0-0.4,0.1-0.7,0.1l0.9,1.6l0.9,1.6c0.1,0.1,0.2,0.3,0.3,0.5h-0.5h-0.6l-0.4-0.8c-0.1-0.2-0.1-0.3-0.2-0.4l-0.2-0.5l-1.2-2.1 c0-0.1-0.1-0.2-0.2-0.4c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.6c0.2-0.3,0.2-0.6,0.2-0.9 c0-0.2,0-0.3-0.1-0.5c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0h-0.7h-0.6 c-0.1,2.5-0.2,4.8-0.2,6.9h-0.5L1091,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1091,360.4l0.1-1.5l0.1-2.8l0.1-2.3c0-0.5,0-0.8,0-1h1h0.8h0.7c0.3,0,0.6,0,0.9,0.1c0.5,0.1,1,0.5,1.2,0.9 c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.2-0.3,0.3-0.5,0.5c-0.2,0.1-0.4,0.2-0.6,0.2 c-0.2,0-0.4,0.1-0.7,0.1l0.9,1.6l0.9,1.6c0.1,0.1,0.2,0.3,0.3,0.5h-0.5h-0.6l-0.4-0.8c-0.1-0.2-0.1-0.3-0.2-0.4l-0.2-0.5l-1.2-2.1 c0-0.1-0.1-0.2-0.2-0.4c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.6c0.2-0.3,0.2-0.6,0.2-0.9 c0-0.2,0-0.3-0.1-0.5c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0h-0.7h-0.6 c-0.1,2.5-0.2,4.8-0.2,6.9h-0.5L1091,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1097,360.4l0.1-2.1l0.1-3.9v-0.9c0-0.2,0-0.5,0-0.7h4.6c0,0.3,0,0.5,0,0.8l-0.5,0c-0.1,0-0.3,0-0.6,0 s-0.6,0-0.8,0c-0.8,0-1.4,0-1.7,0l-0.1,2.6c0.5,0,1,0,1.4,0c0.4,0,1.1,0,1.8,0c0,0.3,0,0.5,0,0.8l-1.8,0c-0.4,0-0.8,0-1.5,0 l-0.1,2.8h0.5c1,0,1.6,0,2,0c0.3,0,0.7,0,1.1,0c0,0.3,0,0.5,0,0.8h-2.1H1097z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1097,360.4l0.1-2.1l0.1-3.9v-0.9c0-0.2,0-0.5,0-0.7h4.6c0,0.3,0,0.5,0,0.8l-0.5,0c-0.1,0-0.3,0-0.6,0 s-0.6,0-0.8,0c-0.8,0-1.4,0-1.7,0l-0.1,2.6c0.5,0,1,0,1.4,0c0.4,0,1.1,0,1.8,0c0,0.3,0,0.5,0,0.8l-1.8,0c-0.4,0-0.8,0-1.5,0 l-0.1,2.8h0.5c1,0,1.6,0,2,0c0.3,0,0.7,0,1.1,0c0,0.3,0,0.5,0,0.8h-2.1H1097z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1104.9,356.4h2.3l-1-3L1104.9,356.4z M1102.1,360.4l0.9-1.9l2.4-5.1l0.3-0.6h1.2l0.9,2.7l1.7,4.9h-0.5h-0.6 c-0.1-0.4-0.3-0.9-0.5-1.6c-0.2-0.7-0.4-1.2-0.5-1.7h-2.8l-0.8,1.7l-0.7,1.5h-0.5H1102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1104.9,356.4h2.3l-1-3L1104.9,356.4z M1102.1,360.4l0.9-1.9l2.4-5.1l0.3-0.6h1.2l0.9,2.7l1.7,4.9h-0.5h-0.6 c-0.1-0.4-0.3-0.9-0.5-1.6c-0.2-0.7-0.4-1.2-0.5-1.7h-2.8l-0.8,1.7l-0.7,1.5h-0.5H1102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1110.2,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.7,0.3,1,0.4c0.3,0.1,0.6,0.1,0.8,0.1c0.3,0,0.5-0.1,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.5l-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.2,0,0.5,0.1,0.9 c-0.5-0.2-1-0.3-1.4-0.3c-0.3,0-0.5,0-0.7,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5l0.6,0.5c0.3,0.3,0.6,0.5,0.8,0.7 c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.4,0.1,0.5c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.5-0.5,0.6 c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.7-0.1C1110.9,360.4,1110.5,360.3,1110.2,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1110.2,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.7,0.3,1,0.4c0.3,0.1,0.6,0.1,0.8,0.1c0.3,0,0.5-0.1,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.5l-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.2,0,0.5,0.1,0.9 c-0.5-0.2-1-0.3-1.4-0.3c-0.3,0-0.5,0-0.7,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5l0.6,0.5c0.3,0.3,0.6,0.5,0.8,0.7 c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.4,0.1,0.5c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.5-0.5,0.6 c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.7-0.1C1110.9,360.4,1110.5,360.3,1110.2,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1115.5,360.4l0.1-2.1l0.2-3.9v-0.9c0-0.2,0-0.5,0-0.7h4.6c0,0.3,0,0.5,0,0.8l-0.5,0c-0.1,0-0.3,0-0.6,0 s-0.6,0-0.8,0c-0.8,0-1.4,0-1.7,0l-0.1,2.6c0.5,0,1,0,1.4,0s1.1,0,1.8,0c0,0.3,0,0.5,0,0.8l-1.8,0c-0.4,0-0.8,0-1.5,0l-0.1,2.8 h0.5c1,0,1.6,0,2,0s0.7,0,1.1,0c0,0.3,0,0.5,0,0.8h-2.1H1115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1115.5,360.4l0.1-2.1l0.2-3.9v-0.9c0-0.2,0-0.5,0-0.7h4.6c0,0.3,0,0.5,0,0.8l-0.5,0c-0.1,0-0.3,0-0.6,0 s-0.6,0-0.8,0c-0.8,0-1.4,0-1.7,0l-0.1,2.6c0.5,0,1,0,1.4,0s1.1,0,1.8,0c0,0.3,0,0.5,0,0.8l-1.8,0c-0.4,0-0.8,0-1.5,0l-0.1,2.8 h0.5c1,0,1.6,0,2,0s0.7,0,1.1,0c0,0.3,0,0.5,0,0.8h-2.1H1115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1125.6,356.1h2.5c-0.1,1.1-0.1,2.5-0.2,4c-0.9,0.2-1.8,0.4-2.7,0.4c-0.5,0-1.1-0.1-1.6-0.2 c-0.5-0.1-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.4-1.1-0.3-2.3,0.1-3.3c0.2-0.5,0.5-1,0.9-1.4c0.4-0.4,0.8-0.6,1.3-0.8 c0.5-0.2,1.1-0.3,1.7-0.2c0.7,0,1.5,0.1,2.2,0.3c0,0.3,0,0.6,0.1,0.9c-0.4-0.1-0.8-0.3-1.3-0.4c-0.3-0.1-0.7-0.1-1-0.1 c-0.5,0-0.9,0.1-1.3,0.2c-0.4,0.1-0.8,0.4-1.1,0.7c-0.3,0.3-0.6,0.7-0.7,1.2c-0.2,0.5-0.2,0.9-0.2,1.4c0,0.4,0.1,0.8,0.2,1.2 c0.1,0.4,0.3,0.7,0.6,0.9c0.3,0.3,0.6,0.4,0.9,0.6c0.4,0.1,0.8,0.2,1.2,0.2c0.3,0,0.6,0,0.8-0.1c0.3,0,0.7-0.1,1-0.2l0.1-2.6h-0.5 c-0.3,0-0.7,0-1.1,0C1125.6,356.5,1125.6,356.3,1125.6,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1125.6,356.1h2.5c-0.1,1.1-0.1,2.5-0.2,4c-0.9,0.2-1.8,0.4-2.7,0.4c-0.5,0-1.1-0.1-1.6-0.2 c-0.5-0.1-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.4-1.1-0.3-2.3,0.1-3.3c0.2-0.5,0.5-1,0.9-1.4c0.4-0.4,0.8-0.6,1.3-0.8 c0.5-0.2,1.1-0.3,1.7-0.2c0.7,0,1.5,0.1,2.2,0.3c0,0.3,0,0.6,0.1,0.9c-0.4-0.1-0.8-0.3-1.3-0.4c-0.3-0.1-0.7-0.1-1-0.1 c-0.5,0-0.9,0.1-1.3,0.2c-0.4,0.1-0.8,0.4-1.1,0.7c-0.3,0.3-0.6,0.7-0.7,1.2c-0.2,0.5-0.2,0.9-0.2,1.4c0,0.4,0.1,0.8,0.2,1.2 c0.1,0.4,0.3,0.7,0.6,0.9c0.3,0.3,0.6,0.4,0.9,0.6c0.4,0.1,0.8,0.2,1.2,0.2c0.3,0,0.6,0,0.8-0.1c0.3,0,0.7-0.1,1-0.2l0.1-2.6h-0.5 c-0.3,0-0.7,0-1.1,0C1125.6,356.5,1125.6,356.3,1125.6,356.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1129.8,352.7h1l-0.2,4.3v0.5v0.1c0,0.4,0.1,0.8,0.2,1.2c0.1,0.3,0.4,0.5,0.7,0.7c0.4,0.2,0.8,0.2,1.2,0.2 c0.3,0,0.6,0,0.9-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3,0.1-0.8,0.1-1.5l0.1-1.8 c0-0.7,0-1.4,0.1-2.1h1l-0.1,2.6l-0.1,2.2c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.3-0.3,0.4 c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.2-0.7,0.3c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.7,0-1.1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3 c-0.2-0.1-0.4-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.4,0-0.7,0-1.2c0-0.4,0.1-1.1,0.1-2 S1129.8,353.2,1129.8,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1129.8,352.7h1l-0.2,4.3v0.5v0.1c0,0.4,0.1,0.8,0.2,1.2c0.1,0.3,0.4,0.5,0.7,0.7c0.4,0.2,0.8,0.2,1.2,0.2 c0.3,0,0.6,0,0.9-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3,0.1-0.8,0.1-1.5l0.1-1.8 c0-0.7,0-1.4,0.1-2.1h1l-0.1,2.6l-0.1,2.2c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.2,0.3-0.3,0.4 c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.2-0.7,0.3c-0.4,0.1-0.8,0.1-1.2,0.1c-0.4,0-0.7,0-1.1-0.1c-0.3-0.1-0.6-0.2-0.8-0.3 c-0.2-0.1-0.4-0.3-0.6-0.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.4,0-0.7,0-1.2c0-0.4,0.1-1.1,0.1-2 S1129.8,353.2,1129.8,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1137.2,360.4l0.1-1.5l0.1-2.8l0.1-2.3c0-0.5,0-0.8,0-1h1h0.8h0.7c0.3,0,0.6,0,0.9,0.1c0.3,0,0.5,0.2,0.7,0.3 c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.2-0.3,0.3-0.5,0.5 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0.1-0.7,0.1l0.9,1.6l0.9,1.6c0.1,0.1,0.2,0.3,0.3,0.5h-0.5h-0.6l-0.4-0.8 c-0.1-0.2-0.2-0.3-0.2-0.4s-0.2-0.3-0.2-0.5l-1.2-2.1l-0.2-0.4c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.6-0.1,0.9-0.2 c0.3-0.1,0.5-0.3,0.7-0.6c0.2-0.3,0.2-0.6,0.2-0.9c0-0.2,0-0.3-0.1-0.5c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0h-0.7h-0.6c-0.1,2.5-0.2,4.8-0.2,6.9h-0.5L1137.2,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1137.2,360.4l0.1-1.5l0.1-2.8l0.1-2.3c0-0.5,0-0.8,0-1h1h0.8h0.7c0.3,0,0.6,0,0.9,0.1c0.3,0,0.5,0.2,0.7,0.3 c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.2,0.1,0.5,0.1,0.8c0,0.3,0,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.2-0.3,0.3-0.5,0.5 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4,0.1-0.7,0.1l0.9,1.6l0.9,1.6c0.1,0.1,0.2,0.3,0.3,0.5h-0.5h-0.6l-0.4-0.8 c-0.1-0.2-0.2-0.3-0.2-0.4s-0.2-0.3-0.2-0.5l-1.2-2.1l-0.2-0.4c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.6-0.1,0.9-0.2 c0.3-0.1,0.5-0.3,0.7-0.6c0.2-0.3,0.2-0.6,0.2-0.9c0-0.2,0-0.3-0.1-0.5c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2 c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0h-0.7h-0.6c-0.1,2.5-0.2,4.8-0.2,6.9h-0.5L1137.2,360.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1147,353.3c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.2-0.7,0.4-1,0.7c-0.3,0.3-0.5,0.7-0.6,1.1 c-0.1,0.4-0.2,0.9-0.2,1.3c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.3,0.7,0.6,1c0.3,0.3,0.6,0.5,0.9,0.6c0.4,0.1,0.7,0.2,1.1,0.2 c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.4,0.9-0.7c0.3-0.3,0.5-0.7,0.6-1.1c0.1-0.4,0.2-0.9,0.2-1.3c0-0.4-0.1-0.8-0.2-1.3 c-0.1-0.4-0.3-0.7-0.6-1c-0.2-0.3-0.6-0.5-0.9-0.6C1147.8,353.4,1147.4,353.3,1147,353.3z M1147.1,352.6c0.5,0,1,0.1,1.5,0.2 c0.5,0.2,0.9,0.4,1.2,0.8c0.3,0.4,0.6,0.8,0.8,1.2c0.2,0.5,0.2,1,0.2,1.5c0,0.6-0.1,1.1-0.2,1.7c-0.2,0.5-0.4,1-0.8,1.3 c-0.4,0.4-0.8,0.7-1.3,0.8c-0.5,0.2-1.1,0.3-1.6,0.3c-0.5,0-1-0.1-1.5-0.2c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.8-0.7-1.2 c-0.2-0.5-0.2-1-0.2-1.5c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.4-1,0.8-1.4c0.4-0.4,0.8-0.6,1.3-0.8 C1146,352.7,1146.5,352.6,1147.1,352.6L1147.1,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1147,353.3c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.2-0.7,0.4-1,0.7c-0.3,0.3-0.5,0.7-0.6,1.1 c-0.1,0.4-0.2,0.9-0.2,1.3c0,0.4,0.1,0.8,0.2,1.2c0.1,0.4,0.3,0.7,0.6,1c0.3,0.3,0.6,0.5,0.9,0.6c0.4,0.1,0.7,0.2,1.1,0.2 c0.4,0,0.8-0.1,1.2-0.2c0.4-0.1,0.7-0.4,0.9-0.7c0.3-0.3,0.5-0.7,0.6-1.1c0.1-0.4,0.2-0.9,0.2-1.3c0-0.4-0.1-0.8-0.2-1.3 c-0.1-0.4-0.3-0.7-0.6-1c-0.2-0.3-0.6-0.5-0.9-0.6C1147.8,353.4,1147.4,353.3,1147,353.3z M1147.1,352.6c0.5,0,1,0.1,1.5,0.2 c0.5,0.2,0.9,0.4,1.2,0.8c0.3,0.4,0.6,0.8,0.8,1.2c0.2,0.5,0.2,1,0.2,1.5c0,0.6-0.1,1.1-0.2,1.7c-0.2,0.5-0.4,1-0.8,1.3 c-0.4,0.4-0.8,0.7-1.3,0.8c-0.5,0.2-1.1,0.3-1.6,0.3c-0.5,0-1-0.1-1.5-0.2c-0.5-0.2-0.9-0.4-1.2-0.8c-0.3-0.3-0.6-0.8-0.7-1.2 c-0.2-0.5-0.2-1-0.2-1.5c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.4-1,0.8-1.4c0.4-0.4,0.8-0.6,1.3-0.8 C1146,352.7,1146.5,352.6,1147.1,352.6L1147.1,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1151.6,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.6,0.3,1,0.4c0.3,0.1,0.6,0.1,0.8,0.1c0.3,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.5l-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.2,0,0.5,0.1,0.9 c-0.5-0.2-1-0.3-1.4-0.3c-0.3,0-0.5,0-0.8,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5c0.1,0,0.3,0.2,0.6,0.5s0.6,0.5,0.8,0.7 c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.5,0.1,0.9-0.1,1.4c-0.1,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.7,0.3 c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.5,0-0.7-0.1C1152.3,360.4,1151.9,360.3,1151.6,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1151.6,360.2c0-0.4,0-0.7-0.1-0.9c0.3,0.2,0.6,0.3,1,0.4c0.3,0.1,0.6,0.1,0.8,0.1c0.3,0,0.5,0,0.7-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.5l-0.9-0.8 l-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.4 c0-0.3,0.1-0.6,0.2-0.9c0.2-0.3,0.4-0.5,0.7-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.5,0,1,0.1,1.4,0.2c0,0.2,0,0.5,0.1,0.9 c-0.5-0.2-1-0.3-1.4-0.3c-0.3,0-0.5,0-0.8,0.2c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.3,0.3,0.5,0.5c0.1,0,0.3,0.2,0.6,0.5s0.6,0.5,0.8,0.7 c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.5,0.1,0.9-0.1,1.4c-0.1,0.2-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.7,0.3 c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.5,0-0.7-0.1C1152.3,360.4,1151.9,360.3,1151.6,360.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M967.7,339.9c0.1,0.4,0.1,0.7,0.2,1c0.2,0.7,0.5,1.4,1,2.1c0.4,0.6,1,1.1,1.6,1.4c0.6,0.4,1.3,0.5,2,0.5 c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.1-0.5,1.5-0.8c0.4-0.4,0.8-0.9,1-1.5c0.3-0.6,0.4-1.3,0.4-2c0-0.8-0.2-1.5-0.6-2.2 c-0.3-0.6-0.8-1.2-1.4-1.6c-0.5-0.5-1.1-0.8-1.8-1.1c-0.6-0.3-1.2-0.5-1.8-0.6c-0.8-0.2-1.6-0.5-2.4-0.9c-0.8-0.5-1.4-1-2-1.7 c-0.6-0.7-1.1-1.5-1.4-2.3c-0.4-1-0.6-2-0.6-3c0-1,0.2-1.9,0.6-2.8c0.4-0.8,0.9-1.6,1.6-2.2c0.6-0.6,1.4-1.1,2.2-1.5 c0.8-0.3,1.7-0.5,2.6-0.5c1.2,0,2.4,0.3,3.5,0.9c0.9,0.5,1.6,1.3,2.2,2.1c0.5,0.8,0.9,1.7,1.1,2.7c0.1,0.4,0.2,0.8,0.2,1.2h-2.8 c-0.1-0.2-0.1-0.5-0.2-0.7c-0.2-0.6-0.5-1.2-0.9-1.7c-0.4-0.5-0.9-0.9-1.4-1.1c-0.5-0.3-1.1-0.5-1.6-0.5c-0.5,0-1.1,0.1-1.6,0.3 c-0.5,0.2-0.9,0.5-1.3,0.8c-0.4,0.4-0.7,0.8-1,1.3c-0.2,0.5-0.4,1.1-0.4,1.7c0,0.7,0.1,1.4,0.5,2.1c0.3,0.6,0.7,1.1,1.2,1.5 c0.5,0.4,1,0.8,1.6,1.1c0.6,0.2,1.2,0.4,1.7,0.6c0.9,0.2,1.8,0.6,2.6,1c0.8,0.5,1.6,1,2.2,1.7c0.7,0.7,1.2,1.5,1.5,2.4 c0.4,1,0.6,2,0.6,3.1c0,1.1-0.2,2.2-0.6,3.2c-0.7,1.8-2.1,3.2-4,3.7c-0.9,0.4-1.9,0.5-2.9,0.5c-1,0-2-0.3-2.9-0.7 c-0.9-0.5-1.8-1.2-2.5-2c-0.7-0.9-1.3-1.9-1.7-2.9c-0.3-0.7-0.5-1.5-0.5-2.3L967.7,339.9z M998.4,320.2v2.8h-10.7v9.1h11.1v2.8 h-11.1v9.1h11.2v2.8H985v-26.7H998.4z M1017.9,344.3c4.6,0,8.6-2.8,10.3-7l0-0.3c0-0.3,0-0.8-0.4-0.8h-13.2l0-2.4h17.1 c-0.4,7.4-6.3,13.3-13.9,13.3c-7.7,0-13.9-6.2-13.9-13.9c0-7.7,6.2-13.9,13.9-13.9c5.4,0,9.8,2.9,12.4,7.5h-3.3 c-3.5-5-10.4-6.2-15.4-2.7c-5,3.5-6.2,10.4-2.7,15.4C1010.9,342.6,1014.3,344.3,1017.9,344.3L1017.9,344.3z M1038.7,339.2 c0.2,6.7,11.1,7.4,11.7-0.5v-18.3h2.6v18.4c0,0.5-0.1,0.9-0.2,1.4c-2.3,10.3-16.6,8.5-16.7-0.9v-19.1h2.6V339.2z M1058.5,346.5 h2.6V323h6.8c1.5,0,4.9,1.9,4.9,6.1c0,3.3-2.2,5.1-5.3,5.1c-0.9,0.1-1.8,0-2.7-0.1l8,12.8h3l-6.9-10.8c1.8,0,6.7-1.3,6.7-7.5 c0.1-4.4-3.5-8.1-7.9-8.1h-9.2V346.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1153.9,310.8v8.9h4.4v5.3h-4.4v21.2h-6V325h-4.4v-5.3h4.4v-8.8H1153.9z M1118.1,329.4h16.3 c-1.8-3.5-4.5-5.2-8-5.2C1122.5,324.1,1119.8,325.9,1118.1,329.4z M1140.3,334.4h-22.8c0.5,2.6,1.6,3.7,3.4,4.9 c1.7,1.2,3.7,1.8,5.8,1.8c2.3,0,4.6-0.8,6.4-2.2h6.5c-3.3,4.7-8,7.1-13.2,7.1c-4,0-7.3-1.3-10-3.9c-2.6-2.5-4.1-6-4-9.6 c0-3.5,1.4-6.9,4-9.3c5.5-5.3,14.3-5.3,19.8,0.1C1139,325.9,1140.4,330.2,1140.3,334.4z M1083.7,345.9l-0.1-26.5h5.7l0,3.2 c1.6-1.7,4.1-3.7,8.7-3.6c5.9,0.1,9.2,6,9.2,8.1l0.3,18.8h-5.6l-0.4-17.2c0-1.4-1.3-4-5.2-4.1c-6.1-0.3-7,4.8-7,6.9v14.4H1083.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "puntos_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1150.5,296.2c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7s-6.1,13.7-13.7,13.7 C1156.7,309.8,1150.5,303.7,1150.5,296.2L1150.5,296.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1155.4,287.8c0,0,0.1-0.1,0.3-0.4c0.5-0.5,1-1,1.6-1.5l1.4,1.7c-0.5,0.5-1,1-1.5,1.6L1155.4,287.8z  M1158,285.4c3.6-2.5,7.9-2.3,12.5,0.3l-0.2,0.3c-3.7-2.1-7.9-1.2-11,1.1L1158,285.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1171.6,304.8l0.4,0.9l-2.5,1.6l-0.8-1.1C1169.8,305.8,1170.7,305.3,1171.6,304.8z M1173,304l0.4,0.9 l-1,0.7l-0.4-0.9C1172.3,304.4,1172.7,304.2,1173,304L1173,304z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1172,321.9c0-6,4.9-10.9,10.9-10.9c6,0,10.9,4.9,10.9,10.9s-4.9,10.9-10.9,10.9 C1176.9,332.9,1172,328,1172,321.9C1172,322,1172,322,1172,321.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1175.9,315.3c0,0,0.1-0.1,0.3-0.3c0.4-0.4,0.8-0.8,1.3-1.2l1.1,1.4c-0.4,0.4-0.8,0.8-1.2,1.2L1175.9,315.3 z M1178,313.4c2.9-2,6.3-1.9,10,0.3l-0.1,0.2c-2.9-1.7-6.3-0.9-8.8,0.9L1178,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1188.9,328.9l0.3,0.8l-1.9,1.3l-0.6-0.9C1187.4,329.6,1188.1,329.3,1188.9,328.9z M1189.9,328.2l0.3,0.7 l-0.8,0.5l-0.3-0.7C1189.4,328.5,1189.7,328.4,1189.9,328.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1161.9,343.6c0-4.2,3.4-7.7,7.7-7.7c4.2,0,7.7,3.4,7.7,7.7c0,4.2-3.4,7.7-7.7,7.7c0,0,0,0,0,0 C1165.3,351.3,1161.9,347.9,1161.9,343.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1164.6,339c0,0,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.6,0.9-0.8l0.8,1c-0.3,0.3-0.6,0.6-0.8,0.9L1164.6,339z  M1166.1,337.6c2-1.4,4.4-1.3,7,0.2l-0.1,0.1c-2.1-1.2-4.4-0.7-6.2,0.6L1166.1,337.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1173.7,348.5l0.2,0.5l-1.4,0.9l-0.4-0.6C1172.7,349,1173.2,348.8,1173.7,348.5z M1174.5,348l0.2,0.5 l-0.6,0.4l-0.2-0.5C1174.1,348.3,1174.3,348.2,1174.5,348L1174.5,348z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M511.9,227.4c0-15.2,12.3-27.5,27.5-27.5c15.2,0,27.5,12.3,27.5,27.5s-12.3,27.5-27.5,27.5 C524.3,254.9,511.9,242.6,511.9,227.4L511.9,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M521.7,210.7c0,0,0.2-0.3,0.7-0.8c1-1.1,2.1-2.1,3.2-3l2.7,3.5c-1.1,1-2.1,2-3,3.1L521.7,210.7z M527,205.9 c7.3-5,15.8-4.7,25.2,0.7l-0.4,0.5c-7.4-4.2-15.8-2.4-22.1,2.3L527,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M554.3,244.8l0.8,1.9l-4.9,3.2l-1.5-2.3C550.6,246.9,552.5,245.9,554.3,244.8z M557,243.2l0.8,1.8l-2,1.3 l-0.8-1.9C555.7,244.1,556.4,243.7,557,243.2L557,243.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegurnetB);
export default __webpack_public_path__ + "static/media/segurnetB.f724261a0e65925e67c4e168962d004d.svg";
export { ForwardRef as ReactComponent };